import { useMobileSidebar } from '../hooks/useMobileSidebar';
import React, { useMemo, useState, useCallback, useEffect } from 'react';



import { useNavigate } from 'react-router-dom';



import { useAuth } from '../hooks/useAuth';



import MainLayout from '../components/layout/MainLayout';



import PointageModule from '../components/shared/PointageModule';



import PersonnelManagementModule from '../components/shared/PersonnelManagementModule';



import { TaskManagementModule } from '../components/rh';
import MaPerformance from '../components/rh/MaPerformance';
import PreuvesPanel from '../components/shared/PreuvesPanel';
import ObjectifsEmployesModule from '../components/shared/ObjectifsEmployesModule';
import MesDemandesPermission from '../components/employe/MesDemandesPermission';



import useDeptDashboard from '../hooks/useDeptDashboard';
import TaskToggleWithPreuve from '../components/shared/TaskToggleWithPreuve';



import ObjectifsEquipePanel from '../components/shared/ObjectifsEquipePanel'; // eslint-disable-line no-unused-vars



import api from '../services/api';







// D�partement Marketing = ID 4 (� ajuster selon ta BDD)



const DEPT_ID = 23; // Marketing







const TABS = [

  { id: 'vue-globale', label: '🔹 Vue globale' },

  { id: 'personnel', label: '🔹 Personnel' },

  { id: 'mon-equipe', label: '🔹 Mon équipe' },

  { id: 'gestion-taches', label: '🔹 Gestion Tâches' },

  { id: 'ma-performance', label: '⭐ Ma Performance' },

  { id: 'taches', label: '✓ Tâches' },

  { id: 'agenda', label: '🔹 Agenda' },

  { id: 'projets', label: '🔹 Projets' },

  { id: 'permissions', label: '📝 Mes Permissions' },

  { id: 'documents', label: '📁 Documents' },

];







function Pbar({ pct, color }) {



  const c = color || (pct >= 70 ? '#4caf50' : pct >= 40 ? '#ff9800' : '#ef5350');



  return (



    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>



      <div style={{ flex: 1, height: 6, background: 'rgba(255,255,255,.08)', borderRadius: 99, overflow: 'hidden' }}>



        <div style={{ width: `${pct}%`, height: '100%', background: c, transition: 'width .3s' }} />



      </div>



      <span style={{ fontSize: 10, color: '#778', width: 28, textAlign: 'right' }}>{pct}%</span>



    </div>



  );



}







function Badge({ variant = 'gold', children }) {



  const colors = {



    gold: { background: 'rgba(201,168,76,0.15)', color: '#C9A84C' },



    green: { background: 'rgba(67,160,71,0.15)', color: '#66bb6a' },



    orange: { background: 'rgba(251,140,0,0.15)', color: '#ffb74d' },



    red: { background: 'rgba(229,57,53,0.15)', color: '#ef5350' },



    blue: { background: 'rgba(25,118,210,0.15)', color: '#64b5f6' },



  };



  const s = colors[variant] || colors.gold;



  return <span style={{ ...s, fontSize: 10, padding: '3px 8px', borderRadius: 99, fontWeight: 600 }}>{children}</span>;



}







function ModalWrap({ title, onSave, onClose, children }) {



  return (



    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.75)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>



      <div style={{ background: '#162535', border: '1px solid rgba(255,255,255,.12)', borderRadius: 14, padding: 28, minWidth: 420, maxWidth: 520, width: '90%' }} onClick={e => e.stopPropagation()}>



        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>



          <span style={{ fontSize: 15, fontWeight: 600, color: '#fff' }}>{title}</span>



          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#889', fontSize: 22, cursor: 'pointer' }}>�</button>



        </div>



        {children}



        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 20 }}>



          <button onClick={onClose} style={{ background: 'rgba(255,255,255,.05)', border: '1px solid rgba(255,255,255,.1)', borderRadius: 8, padding: '8px 16px', color: '#aaa', cursor: 'pointer', fontSize: 12 }}>Annuler</button>



          <button onClick={onSave} style={{ background: '#C9A84C', border: 'none', borderRadius: 8, padding: '8px 18px', color: '#000', fontWeight: 600, cursor: 'pointer', fontSize: 12 }}>Enregistrer</button>



        </div>



      </div>



    </div>



  );



}







const Field = ({ label, name, type = 'text', opts, required, form, setForm }) => {



  const handleChange = (e) => {



    setForm(prev => ({ ...prev, [name]: e.target.value }));



  };







  const s = { width: '100%', background: 'rgba(255,255,255,.05)', border: '1px solid rgba(255,255,255,.07)', borderRadius: 8, padding: '9px 12px', color: '#fff', fontFamily: 'inherit', fontSize: 13, outline: 'none' };



  return (



    <div style={{ marginBottom: 12 }}>



      <label style={{ fontSize: 10, color: '#667', textTransform: 'uppercase', letterSpacing: '.8px', display: 'block', marginBottom: 5 }}>



        {label} {required && <span style={{ color: '#ef8080' }}>*</span>}



      </label>



      {opts



        ? <select 



            style={{ ...s, background: '#0d1b2a', border: '1px solid rgba(255,255,255,.15)' }} 



            value={form[name] || ''} 



            onChange={handleChange}



          >



            <option value=''>-- choisir --</option>



            {opts.map(o => <option key={o} value={o} style={{ background: '#0d1b2a' }}>{o}</option>)}



          </select>



        : <input 



            style={s} 



            type={type} 



            value={form[name] || ''} 



            onChange={handleChange}



            autoFocus={required && !form[name]}



          />



      }



    </div>



  );



};







export default function DashboardMarketingPage() {



  const navigate = useNavigate();
  useMobileSidebar();



  const { logout: authLogout } = useAuth();



  const [activeTab, setActiveTab] = useState('vue-globale');



  const [modal, setModal] = useState(null);



  const [projets, setProjets] = useState([]);



  useEffect(() => { api.projects.getAll({ departement_id: DEPT_ID }).then(res => setProjets(res.projects || [])).catch(() => {}); }, []);



  const [form, setForm] = useState({});



  const [search, setSearch] = useState('');







  const {



    employes, setEmployes,



    tasks, setTasks,



    loading, error, refetch,



    createTask, updateTask, toggleTask, deleteTask,



  } = useDeptDashboard({ deptId: DEPT_ID });







  const handleLogout = useCallback(async () => {



    await authLogout();



    navigate('/auth', { replace: true });



  }, [authLogout, navigate]);







  const openModal = useCallback((type, data = {}) => { setForm(data); setModal(type); }, []);



  const closeModal = useCallback(() => { setModal(null); setForm({}); }, []);







  // KPIs calcul�s depuis la BDD



  const presents = employes.filter(e => e.present).length;



  const scoreAvg = employes.length > 0



    ? (employes.reduce((s, e) => s + (e.score || 0), 0) / employes.length).toFixed(1)



    : '0';



  const allObj = employes.flatMap(e => e.objectifs || []);



  const objRate = allObj.length > 0



    ? Math.round(allObj.filter(o => o.statut === 'atteint').length / allObj.length * 100)



    : 0;



  // 🔹 Filtrer les t�ches du chef connect� pour "Mes t�ches"
  const { user } = useAuth();
  const myTasks = useMemo(() => {
    const userId = user?.id;
    if (!userId) return tasks;
    return tasks.filter(t => t.employee_id === userId);
  }, [tasks, user]);
  const myPendingTasks = myTasks.filter(t => !t.done).length;
  const pendingTasks = myPendingTasks;



  const totalAssigned = employes.reduce((s, e) => s + (e.assignedTasks || []).length, 0);







  const filteredEmployes = useMemo(() => {



    const q = search.trim().toLowerCase();



    if (!q) return employes;



    return employes.filter(e =>



      `${e.prenom} ${e.nom}`.toLowerCase().includes(q) || e.poste.toLowerCase().includes(q)



    );



  }, [search, employes]);







  const F = props => <Field {...props} form={form} setForm={setForm} />;







  const saveTask = async () => {



    if (!form.text) return;



    try {



      if (form._id) await updateTask(form._id, { titre: form.text, priority: form.prio || 'normale', category: form.categorie || 'Projet' });



      else await createTask({ titre: form.text, priority: form.prio || 'normale', category: form.categorie || 'Projet' });



    } catch {



      if (form._id) setTasks(prev => prev.map(t => t.id === form._id ? { ...t, text: form.text, prio: form.prio || 'normale' } : t));



      else setTasks(prev => [...prev, { id: Date.now(), text: form.text, done: false, prio: form.prio || 'normale', date: new Date().toISOString().slice(0, 10) }]);



    }



    closeModal();



  };







  const prioBadge = p => {



    const map = { urgente: 'red', haute: 'orange', normale: 'blue' };



    return <Badge variant={map[p] || 'blue'}>{p}</Badge>;



  };







  return (



    <MainLayout>



      <div style={{ minHeight: '100vh', background: '#090f1a', color: '#fff', display: 'flex', flexDirection: 'column' }}>







        {/* TOPBAR */}



        <div style={{ height: 58, background: '#0d1825', borderBottom: '1px solid rgba(255,255,255,.06)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px', flexShrink: 0 }}>



          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>



            <div style={{ width: 38, height: 38, borderRadius: 10, background: 'linear-gradient(135deg,#C9A84C,#8a6028)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 }}>M</div>



            <div>



              <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 18, fontWeight: 600 }}>FHC Groupe SARL</div>



              <div style={{ fontSize: 9, color: 'rgba(255,255,255,.3)' }}>Dashboard � Chef Marketing & Communication</div>



            </div>



          </div>



          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>



            <div style={{ fontSize: 11, color: '#445', background: '#162535', padding: '5px 12px', borderRadius: 20, border: '1px solid rgba(255,255,255,.07)' }}>



              {new Date().toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}



            </div>



            <button onClick={refetch} style={{ background: 'rgba(255,255,255,.05)', border: '1px solid rgba(255,255,255,.1)', borderRadius: 7, padding: '6px 12px', color: '#aaa', fontSize: 11, cursor: 'pointer' }}>? Actualiser</button>

            <button onClick={handleLogout} style={{ background: 'rgba(239,83,80,.1)', border: '1px solid rgba(239,83,80,.3)', borderRadius: 7, padding: '6px 14px', color: '#ef8080', fontSize: 11, cursor: 'pointer' }}>🔹 D�connexion</button>

          </div>



        </div>







        {/* TABS */}



        <div style={{ display: 'flex', gap: 4, borderBottom: '1px solid rgba(255,255,255,.06)', padding: '0 24px', overflowX: 'auto', background: '#0d1825', flexShrink: 0 }}>



          {TABS.map(tab => (



            <div key={tab.id} onClick={() => setActiveTab(tab.id)}



              style={{ padding: '11px 16px', fontSize: 12, color: activeTab === tab.id ? '#C9A84C' : '#667', cursor: 'pointer', borderBottom: activeTab === tab.id ? '2px solid #C9A84C' : '2px solid transparent', transition: 'all .15s', whiteSpace: 'nowrap' }}>



              {tab.label}



            </div>



          ))}



        </div>







        {/* LOADING / ERROR */}



        {loading && (



          <div style={{ padding: '40px', textAlign: 'center', color: '#C9A84C', fontSize: 14 }}>



            Chargement des donn�es Marketing�



          </div>



        )}



        {error && !loading && (



          <div style={{ margin: '12px 24px', padding: '10px 16px', background: 'rgba(239,83,80,.1)', border: '1px solid rgba(239,83,80,.3)', borderRadius: 8, fontSize: 12, color: '#ef8080' }}>



            ⚠? {error}



          </div>



        )}







        {/* CONTENT */}



        {!loading && (



          <div style={{ flex: 1, overflow: 'auto', padding: 24 }}>







            {/* VUE GLOBALE */}



            {activeTab === 'vue-globale' && (



              <div>



                <div style={{ marginBottom: 20 }}>



                  <h2 style={{ fontFamily: 'Cormorant Garamond,serif', fontSize: 24, fontWeight: 600, marginBottom: 6 }}>Dashboard Chef Marketing</h2>



                  <p style={{ fontSize: 12, color: '#667' }}>Marketing Digital & Communication � {employes.length} collaborateurs � Donn�es temps r�el</p>



                </div>







                <PointageModule currentUser={{ nom: 'Chef Marketing' }} />







                {/* KPIs */}



                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(200px,1fr))', gap: 12, margin: '20px 0' }}>



                  {[



                    { icon: '🔹', val: employes.length, label: 'Collaborateurs', color: '#42a5f5' },



                    { icon: '?', val: presents, label: 'Pr�sents aujourd\'hui', color: '#4caf50' },



                    { icon: '🔹', val: objRate + '%', label: 'Objectifs atteints', color: '#C9A84C' },



                    { icon: '?', val: scoreAvg, label: 'Score moyen /10', color: '#ab47bc' },



                    { icon: '🔹', val: pendingTasks, label: 'T�ches en attente', color: '#ff9800' },



                  ].map(k => (



                    <div key={k.label} style={{ background: '#111f30', border: '1px solid rgba(255,255,255,.06)', borderRadius: 12, padding: 16, position: 'relative', overflow: 'hidden' }}>



                      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: k.color }} />



                      <div style={{ fontSize: 20, marginBottom: 10 }}>{k.icon}</div>



                      <div style={{ fontFamily: 'Cormorant Garamond,serif', fontSize: 30, fontWeight: 600, color: k.color, marginBottom: 4, lineHeight: 1 }}>{k.val}</div>



                      <div style={{ fontSize: 11, color: 'rgba(255,255,255,.6)' }}>{k.label}</div>



                    </div>



                  ))}



                </div>







                {/* Tableau �quipe */}



                <div style={{ background: '#111f30', border: '1px solid rgba(255,255,255,.06)', borderRadius: 14, padding: 18, marginBottom: 16 }}>



                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>



                    <div style={{ fontSize: 13, fontWeight: 600 }}>🔹 Suivi �quipe Marketing</div>



                    <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Rechercher�"



                      style={{ background: 'rgba(255,255,255,.05)', border: '1px solid rgba(255,255,255,.07)', borderRadius: 8, padding: '6px 12px', color: '#fff', fontSize: 12, outline: 'none', width: 200 }} />



                  </div>



                  {employes.length === 0 ? (



                    <div style={{ textAlign: 'center', padding: '30px 0', color: '#445', fontSize: 12 }}>Aucun collaborateur dans ce d�partement.</div>



                  ) : (



                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>



                      <thead>



                        <tr>{['Collaborateur', 'Poste', 'Filiale', 'Pr�sence', 'T�ches', 'Score'].map(h => (



                          <th key={h} style={{ textAlign: 'left', fontSize: 10, letterSpacing: .8, textTransform: 'uppercase', color: '#667', padding: '10px 12px', borderBottom: '1px solid rgba(255,255,255,.08)' }}>{h}</th>



                        ))}</tr>



                      </thead>



                      <tbody>



                        {filteredEmployes.map(e => {



                          const pct = e.tachesQuot > 0 ? Math.round(e.tachesDone / e.tachesQuot * 100) : 0;



                          return (



                            <tr key={e.id}>



                              <td style={{ padding: '10px 12px', color: '#ccc', borderBottom: '1px solid rgba(255,255,255,.05)' }}>



                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>



                                  <div style={{ width: 28, height: 28, borderRadius: '50%', background: e.color + '22', color: e.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 700 }}>{e.av}</div>



                                  <span style={{ fontWeight: 600 }}>{e.prenom} {e.nom}</span>



                                </div>



                              </td>



                              <td style={{ padding: '10px 12px', color: '#ccc', borderBottom: '1px solid rgba(255,255,255,.05)' }}>{e.poste}</td>



                              <td style={{ padding: '10px 12px', color: '#ccc', borderBottom: '1px solid rgba(255,255,255,.05)' }}>{e.filiale}</td>



                              <td style={{ padding: '10px 12px', borderBottom: '1px solid rgba(255,255,255,.05)' }}>



                                <Badge variant={e.present ? 'green' : 'red'}>{e.present ? '? Pr�sent' : '? Absent'}</Badge>



                              </td>



                              <td style={{ padding: '10px 12px', color: '#ccc', borderBottom: '1px solid rgba(255,255,255,.05)', minWidth: 100 }}>



                                {e.tachesQuot > 0 ? <><Pbar pct={pct} /><div style={{ fontSize: 9, color: '#445', marginTop: 2 }}>{e.tachesDone}/{e.tachesQuot}</div></> : '�'}



                              </td>



                              <td style={{ padding: '10px 12px', color: '#ccc', borderBottom: '1px solid rgba(255,255,255,.05)' }}>



                                <span style={{ fontFamily: 'Cormorant Garamond,serif', fontSize: 18, fontWeight: 600, color: e.score >= 8 ? '#66bb6a' : e.score >= 6 ? '#C9A84C' : '#ef8080' }}>{e.score || '�'}</span>



                              </td>



                            </tr>



                          );



                        })}



                      </tbody>



                    </table>



                  )}



                </div>







                {/* Alertes */}



                {employes.filter(e => !e.present || e.score < 6).length > 0 && (



                  <div style={{ background: 'rgba(239,83,80,.08)', border: '1px solid rgba(239,83,80,.25)', borderRadius: 12, padding: 16 }}>



                    <div style={{ fontSize: 13, fontWeight: 600, color: '#ef8080', marginBottom: 10 }}>⚠? Alertes</div>



                    {employes.filter(e => !e.present || e.score < 6).map(e => (



                      <div key={e.id} style={{ fontSize: 12, color: '#ccc', padding: '5px 0', borderBottom: '1px solid rgba(255,255,255,.04)' }}>



                        <strong>{e.prenom} {e.nom}</strong> � {!e.present && 'Absent � '}{e.score < 6 && `Score faible (${e.score}/10)`}



                      </div>



                    ))}



                  </div>



                )}



              </div>



            )}







            {/* PERSONNEL */}



            {activeTab === 'personnel' && (



              <PersonnelManagementModule employes={employes} setEmployes={setEmployes} departmentName="Marketing & Communication" heureLimite="09:00" deptId={DEPT_ID} />



            )}







            {/* MON �QUIPE */}



            {activeTab === 'mon-equipe' && (



              <div>



                <h2 style={{ fontFamily: 'Cormorant Garamond,serif', fontSize: 22, fontWeight: 600, marginBottom: 16 }}>🔹 Mon �quipe � Marketing</h2>



                {/* Heatmap t�ches */}



                <div style={{ background: '#111f30', border: '1px solid rgba(255,255,255,.06)', borderRadius: 14, padding: 18, marginBottom: 16 }}>



                  <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 14 }}>🗑️ Accomplissement des t�ches</div>



                  <div style={{ display: 'grid', gap: 10 }}>



                    {employes.map(e => {



                      const pct = e.tachesQuot > 0 ? Math.round(e.tachesDone / e.tachesQuot * 100) : 0;



                      return (



                        <div key={e.id} style={{ padding: 12, background: 'rgba(255,255,255,.03)', borderRadius: 10 }}>



                          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8, alignItems: 'center' }}>



                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>



                              <div style={{ width: 26, height: 26, borderRadius: '50%', background: e.color + '22', color: e.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 700 }}>{e.av}</div>



                              <span style={{ fontSize: 12, fontWeight: 500 }}>{e.prenom} {e.nom}</span>



                            </div>



                            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>



                              <span style={{ fontSize: 11, color: '#667' }}>{e.tachesDone}/{e.tachesQuot} t�ches</span>



                              <strong style={{ fontSize: 13, color: pct >= 70 ? '#66bb6a' : '#fb8c00' }}>{pct}%</strong>



                            </div>



                          </div>



                          <Pbar pct={pct} />



                          {/* T�ches en attente */}



                          {(e.pendingTasks || []).slice(0, 2).map((t, i) => (



                            <div key={i} style={{ fontSize: 10, color: '#667', marginTop: 4, paddingLeft: 34 }}>



                              � {t.titre} � {prioBadge(t.prio)}



                            </div>



                          ))}



                        </div>



                      );



                    })}



                  </div>



                </div>







                {/* OBJECTIFS */}



                <div style={{ background: '#111f30', border: '1px solid rgba(255,255,255,.06)', borderRadius: 14, padding: 18 }}>



                  <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 14 }}>🔹 Objectifs par collaborateur</div>



                  {employes.map(e => {



                    const objs = e.objectifs || [];



                    const att = objs.filter(o => o.statut === 'atteint').length;



                    return (



                      <div key={e.id} style={{ marginBottom: 16, paddingBottom: 16, borderBottom: '1px solid rgba(255,255,255,.05)' }}>



                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8, alignItems: 'center' }}>



                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>



                            <div style={{ width: 24, height: 24, borderRadius: '50%', background: e.color + '22', color: e.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, fontWeight: 700 }}>{e.av}</div>



                            <span style={{ fontSize: 12, fontWeight: 600 }}>{e.prenom} {e.nom}</span>



                          </div>



                          <span style={{ fontSize: 11, color: att === objs.length && objs.length > 0 ? '#66bb6a' : '#C9A84C' }}>{att}/{objs.length} atteints</span>



                        </div>



                        {objs.length === 0



                          ? <div style={{ fontSize: 11, color: '#445', fontStyle: 'italic', paddingLeft: 32 }}>Aucun objectif d�fini.</div>



                          : objs.map((o, i) => (



                            <div key={o.id || i} style={{ paddingLeft: 32, marginBottom: 6 }}>



                              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 3 }}>



                                <span style={{ fontSize: 10, color: '#aaa' }}>{o.titre}</span>



                                <Badge variant={o.statut === 'atteint' ? 'green' : o.statut === 'retard' ? 'red' : 'orange'}>



                                  {o.statut === 'atteint' ? '?' : o.statut === 'retard' ? '⚠?' : '?'} {o.statut}



                                </Badge>



                              </div>



                              <Pbar pct={o.progression} color={o.statut === 'atteint' ? '#4caf50' : o.statut === 'retard' ? '#ef5350' : '#ff9800'} />



                            </div>



                          ))



                        }



                      </div>



                    );



                  })}



                </div>



              </div>



            )}







            {/* GESTION TÂCHES */}

            {activeTab === 'gestion-taches' && (

              <div>

                <div style={{ marginBottom: 20 }}>

                  <h2 style={{ fontFamily: 'Cormorant Garamond,serif', fontSize: 22, fontWeight: 600, marginBottom: 6 }}>🔹 Gestion des Tâches</h2>

                  <p style={{ fontSize: 12, color: '#667' }}>{totalAssigned} tâche{totalAssigned !== 1 ? 's' : ''} assignée{totalAssigned !== 1 ? 's' : ''}</p>

                </div>

                <PreuvesPanel tasks={tasks} employes={employes} />
              <TaskManagementModule employes={employes} setEmployes={setEmployes} />

              </div>

            )}

            {/* MA PERFORMANCE */}

            {activeTab === 'ma-performance' && (

              <div>

                <div style={{ marginBottom: 20 }}>

                  <h2 style={{ fontFamily: 'Cormorant Garamond,serif', fontSize: 22, fontWeight: 600, marginBottom: 6 }}>⭐ Ma Performance</h2>

                  <p style={{ fontSize: 12, color: '#667' }}>Consultez votre performance personnelle</p>

                </div>

                <MaPerformance />

              </div>

            )}

            {/* OBJECTIFS */}

            {activeTab === 'objectifs' && (

              <div>

                <div style={{ marginBottom: 20 }}>

                  <h2 style={{ fontFamily: 'Cormorant Garamond,serif', fontSize: 22, fontWeight: 600, marginBottom: 6 }}>🎯 Objectifs de l'Équipe</h2>

                  <p style={{ fontSize: 12, color: '#667' }}>{allObj.length} objectif{allObj.length !== 1 ? 's' : ''}</p>

                </div>

                <ObjectifsEmployesModule 
                  employes={employes} 
                  onRefresh={refetch} 
                  isChef={true} 
                />

              </div>

            )}







            {/* MES T�CHES */}



            {activeTab === 'taches' && (



              <div>



                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>



                  <div>



                    <h2 style={{ fontFamily: 'Cormorant Garamond,serif', fontSize: 22, fontWeight: 600, marginBottom: 4 }}>? Mes T�ches</h2>



                    <p style={{ fontSize: 12, color: '#667' }}>{pendingTasks} en attente</p>



                  </div>



                  <button onClick={() => openModal('tache', { prio: 'normale' })}



                    style={{ background: '#C9A84C', border: 'none', borderRadius: 8, padding: '8px 16px', color: '#000', fontWeight: 600, fontSize: 12, cursor: 'pointer' }}>+ Ajouter</button>



                </div>



                <div style={{ background: '#111f30', border: '1px solid rgba(255,255,255,.06)', borderRadius: 14, padding: 18 }}>



                  {myTasks.length === 0



                    ? <div style={{ textAlign: 'center', padding: '30px 0', color: '#445', fontSize: 12 }}>Aucune t�che.</div>



                    : myTasks.map(t => (



                      <div key={t.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 0', borderBottom: '1px solid rgba(255,255,255,.04)' }}>





                          <TaskToggleWithPreuve task={t} onToggle={toggleTask} onToggleWithPreuve={async (id) => { await toggleTask(id); }} />



                        <span style={{ flex: 1, fontSize: 13, color: t.done ? '#445' : '#ccc', textDecoration: t.done ? 'line-through' : 'none' }}>{t.text}</span>



                        {prioBadge(t.prio)}



                        <button onClick={() => openModal('tache', { _id: t.id, text: t.text, prio: t.prio })}



                          style={{ background: 'none', border: 'none', color: '#667', cursor: 'pointer', fontSize: 13 }}>🔹</button>



                        <button onClick={() => deleteTask(t.id)}



                          style={{ background: 'none', border: 'none', color: '#ef5350', cursor: 'pointer', fontSize: 13 }}>🗑️</button>



                      </div>



                    ))



                  }



                </div>



              </div>



            )}







            {/* AGENDA */}



            {activeTab === 'projets' && (



              <div>



                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}><div style={{ fontSize: 16, fontWeight: 700 }}>🔹 Projets du d�partement</div><div style={{ fontSize: 11, color: '#94a3b8' }}>{projets.length} projet{projets.length !== 1 ? 's' : ''}</div></div>



                {projets.length === 0 ? (<div style={{ textAlign: 'center', padding: 40, color: '#445' }}>Aucun projet assign� � ce d�partement.</div>) : projets.map(p => { const sc = { en_cours: '#42a5f5', planification: '#C9A84C', production: '#ff9800', termine: '#66bb6a', annule: '#ef5350', negociation: '#ab47bc' }[p.status] || '#888'; const sl = { en_cours: 'En cours', planification: 'Planification', production: 'Production', termine: 'Termin�', annule: 'Annul�', negociation: 'N�gociation' }[p.status] || p.status; const av = p.progress || 0; return (<div key={p.id} style={{ background: '#162535', borderRadius: 10, padding: 16, marginBottom: 12, border: '1px solid rgba(255,255,255,.06)' }}><div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}><div><div style={{ fontSize: 14, fontWeight: 600, color: '#fff', marginBottom: 4 }}>{p.name}</div><div style={{ fontSize: 11, color: '#667' }}>{p.filiale?.nom || '�'}{p.departement?.nom ? ' � ' + p.departement.nom : ''}</div></div><span style={{ fontSize: 10, fontWeight: 600, padding: '3px 10px', borderRadius: 99, background: sc + '22', color: sc }}>{sl}</span></div><div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 10 }}>{[['Budget', p.budget ? Number(p.budget).toLocaleString('fr-FR') + ' FCFA' : '�'], ['Deadline', p.end_date ? new Date(p.end_date).toLocaleDateString('fr-FR') : '�'], ['Chef', p.owner ? (p.owner.prenom + ' ' + (p.owner.nom || '')) : '�']].map(([l,v]) => (<div key={l} style={{ background: 'rgba(255,255,255,.04)', borderRadius: 8, padding: '8px 10px' }}><div style={{ fontSize: 9, color: '#556', marginBottom: 3 }}>{l}</div><div style={{ fontSize: 11, fontWeight: 600, color: '#ccc' }}>{v}</div></div>))}</div><div style={{ fontSize: 10, color: '#667', marginBottom: 5, display: 'flex', justifyContent: 'space-between' }}><span>Avancement</span><span style={{ fontWeight: 600 }}>{av}%</span></div><div style={{ height: 5, background: 'rgba(255,255,255,.06)', borderRadius: 99 }}><div style={{ width: av+'%', height: '100%', background: av>=70?'#4caf50':av>=40?'#ff9800':'#ef5350', borderRadius: 99 }} /></div></div>); })}



              </div>



            )}



            {/* PERMISSIONS */}

            {activeTab === 'permissions' && (

              <div>

                <MesDemandesPermission />

              </div>

            )}







            {activeTab === 'documents' && (() => { navigate('/documents'); return null; })()}

            {activeTab === 'agenda' && (



              <div style={{ padding: '20px 0', textAlign: 'center', color: '#667' }}>



                <div style={{ fontSize: 32, marginBottom: 12 }}>🔹</div>



                <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8, color: '#aaa' }}>Agenda Marketing</div>



                <div style={{ fontSize: 12 }}>Module agenda disponible depuis le menu principal.</div>



              </div>



            )}



          </div>



        )}







        {/* MODAL T�CHE */}



        {modal === 'tache' && (



          <ModalWrap title={form._id ? 'Modifier la t�che' : 'Nouvelle t�che'} onSave={saveTask} onClose={closeModal}>



            <F label="Titre *" name="text" />



            <F label="Priorit�" name="prio" opts={['urgente', 'haute', 'normale']} />



            <F label="Cat�gorie" name="categorie" opts={['Projet', 'Admin', 'RH', 'Finance', 'Autre']} />



          </ModalWrap>



        )}



      </div>



    </MainLayout>



  );



}




